import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CloseAddIcon from 'app/components/Icons/CloseAddIcon';
import {
  accountNone,
  addBannerBox,
  bannerBtn,
  bannerDesc,
  bannerText,
  cardBox,
  closeButton,
  lastOperationBox,
  mainBoxes,
    searchNone
} from './HomePage.sx';
import useHomePage from './useHomePage';
import AccountsBox from './AccountsBox';
import CurrencyBox from 'app/pages/HomePage/CurrencyBox';
import LastOperations from 'app/components/LastOperations';
import {black1, grayText} from 'app/components/ThemeProvider/colors';
import SearchIcon from "app/components/Icons/SearchIcon";

const HomePage = () => {
  const {
    t,
    isLoadingGetHomePage,
    dataGetHomePage,
    showAddBanner,
    expand,
    showCalculator,
    largeScreens,
    selectValue,
    setSelectValue,
    fromHomePage,
    setFromHomePage,
    setShowCalculator,
    setShowAddBanner,
    handleExpand,
    mediumScreens,
    smallScreens,
  } = useHomePage();

  if (isLoadingGetHomePage) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
        {showAddBanner && (
          <Box sx={addBannerBox}>
            <Box sx={closeButton} onClick={() => setShowAddBanner(false)}>
              <CloseAddIcon />
            </Box>
            <Box sx={bannerDesc}>
              <Typography sx={bannerText}>10 ballıq biznes kredit İllik cəmi 5%-lə</Typography>
              <Button color={'secondary'} sx={bannerBtn}>
                Daha ətraflı
              </Button>
            </Box>
            <img src="/images/img.png" alt="photo-add" height={186} />
          </Box>
        )}
        <Box sx={mainBoxes}>
          <Box sx={cardBox(expand, 'account')}>
            {dataGetHomePage?.accounts_list.length !== 0 ?
              <AccountsBox
                expand={expand}
                accounts={dataGetHomePage?.accounts_list}
                selectedValue={selectValue}
                changeSelectedValue={setSelectValue}
                homePageFlag={setFromHomePage}
              /> :
                <Box sx={accountNone}>
                  <Box sx={searchNone}>
                    <SearchIcon/>
                  </Box>
                  <Typography sx={{fontSize: '16px', color: grayText, maxWidth: '289px'}}>Sizin hal-hazırda əks olunacaq hesabınız yoxdur</Typography>
                  <Typography sx={{fontSize: '18px', fontWeight: 600}}>Hesab açmaq üçün banka müraciət edin.</Typography>
                </Box>
            }
          </Box>
          <Box sx={{ ...cardBox(expand), width: '60%' }}>
            <CurrencyBox
              expand={expand}
              showCalculator={showCalculator}
              largeScreens={largeScreens}
              mediumScreens={mediumScreens}
              smallScreens={smallScreens}
              handleExpand={handleExpand}
              setShowCalculator={setShowCalculator}
              currency={dataGetHomePage?.rates}
            />
          </Box>
        </Box>
        <Box sx={lastOperationBox}>
          <Box sx={{ p: '0 28px' }}>
            <Typography sx={{ fontSize: '22px', color: black1,fontWeight: 600 }}>{t('homePage.lastTransactions')}</Typography>
          </Box>
          <LastOperations
            tableData={dataGetHomePage?.transactions}
            menuHomeButtons={dataGetHomePage?.buttons}
            selectedAccount={selectValue}
            homePage={fromHomePage}
          />
        </Box>
      </Box>
    );
  }
};

export default HomePage;
